import type { ExportItem } from './types';

/** Starting value chosen for phone browsers: a part is held in memory until it downloads. */
export const ZIP_PART_LIMIT_BYTES = 500 * 1024 * 1024;

/** Assumed size of a file whose size is unknown, so parts stay bounded regardless. */
export const UNKNOWN_SIZE_BYTES = 8 * 1024 * 1024;

/** Splits items, in order, into parts no larger than the limit. An oversized file gets its own part. */
export function planParts(items: ExportItem[], limitBytes: number = ZIP_PART_LIMIT_BYTES): ExportItem[][] {
  const parts: ExportItem[][] = [];
  let current: ExportItem[] = [];
  let bytes = 0;
  for (const item of items) {
    const size = item.size ?? UNKNOWN_SIZE_BYTES;
    if (current.length > 0 && bytes + size > limitBytes) {
      parts.push(current);
      current = [];
      bytes = 0;
    }
    current.push(item);
    bytes += size;
  }
  if (current.length > 0) parts.push(current);
  return parts;
}
